import type { JobApplicationFormData } from '#shared/types/JobRequest'
import type { UserId } from '#shared/types/ids'
import type { ValidationRules } from 'last-validator'

import { isEmail, isRequired, validate } from 'last-validator'

export function validateJobRequest(
    jobApplication: JobApplicationFormData,
    needJobMediationAgreement: boolean,
    userId?: UserId
) {
    const validators: ValidationRules<JobApplicationFormData> = {
        email: [isRequired(), isEmail()],
        phone: [isRequired()],
        motivation: [isRequired()],
        cvFile: [isRequired()],
        jobMediationAgreementAccepted: needJobMediationAgreement ? [isRequired()] : [],
        jobApplicationConsentAccepted: [isRequired()]
    }

    if (!userId) {
        validators.firstName = [isRequired()]
        validators.lastName = [isRequired()]
    }

    return validate<JobApplicationFormData>(jobApplication, validators)
}
